import React from 'react';
import { Info } from 'lucide-react';

const APIVersion = () => (
  <div className="rounded-xl border border-gray-200 bg-white p-6 max-w-sm">
    <div className="flex items-center gap-3 mb-3">
      <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#404880]/10">
        <Info size={16} className="text-[#404880]" />
      </div>
      <h3 className="text-sm font-semibold text-gray-900">API Version</h3>
    </div>
    <div className="space-y-1 text-sm text-gray-600">
      <p>Current Version — <span className="font-medium text-gray-900">v0</span></p>
      <p>Released — <span className="font-medium text-gray-900">01 Jan 2025</span></p>
    </div>
    <p className="mt-3 text-xs text-gray-400">No new versions available.</p>
  </div>
);

export default APIVersion;
